import { Reveal, SectionHeading } from "./Reveal";
import { Star, BadgeCheck, TrendingUp } from "lucide-react";

const TESTIMONIALS = [
  {
    quote:
      "The AI agent booked 34 appointments in its first month — most of them after 8 PM when we'd already gone home. It paid for itself in the first week.",
    name: "Dr. Priya Nair",
    role: "Bright Smile Dental, Austin",
    initials: "PN",
    stat: "+41%",
    statLabel: "new patient bookings",
  },
  {
    quote:
      "Our website looks like we paid an agency five figures. TalkLogical built it from our Google profile in two days and the reservation calls never stop.",
    name: "Marco Bellini",
    role: "Trattoria Bella, Chicago",
    initials: "MB",
    stat: "28",
    statLabel: "tables booked by AI / week",
  },
  {
    quote:
      "A burst pipe at 2 AM used to mean a lost job. Now the AI triages the emergency and wakes my on-call tech. We captured $9k of work last month we'd have missed.",
    name: "Dana Whitfield",
    role: "Rapid Flow Plumbing, Denver",
    initials: "DW",
    stat: "$9k",
    statLabel: "recovered in month one",
  },
];

export default function Testimonials() {
  return (
    <section id="testimonials" data-testid="testimonials-section" className="relative py-24 md:py-36 px-4 sm:px-6 lg:px-8 bg-[#0A0D14]/50">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          testId="testimonials-heading"
          kicker="Proof from the field"
          title="Local owners. Real revenue."
          sub="Businesses like yours running on TalkLogical right now."
        />
        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.name} delay={i * 0.12}>
              <figure
                data-testid={`testimonial-card-${i + 1}`}
                className="glow-card group h-full rounded-2xl p-8 flex flex-col"
              >
                <div className="flex items-center gap-1">
                  {Array.from({ length: 5 }).map((_, s) => (
                    <Star key={s} className="h-4 w-4 text-amber-400 fill-amber-400" />
                  ))}
                </div>
                <blockquote className="mt-5 flex-1 text-sm sm:text-base text-slate-300 leading-relaxed">
                  "{t.quote}"
                </blockquote>
                <div className="mt-7 flex items-center gap-4 border-t border-white/10 pt-6">
                  <span className="flex h-11 w-11 items-center justify-center rounded-full bg-gradient-to-br from-cyan-400/25 to-violet-500/25 ring-1 ring-white/15 font-display text-sm font-bold text-slate-100">
                    {t.initials}
                  </span>
                  <div className="flex-1">
                    <p className="flex items-center gap-1.5 text-sm font-semibold text-slate-100">
                      {t.name}
                      <BadgeCheck className="h-4 w-4 text-cyan-400" />
                    </p>
                    <p className="text-xs text-slate-500">{t.role}</p>
                  </div>
                </div>
                <div className="mt-5 flex items-center gap-2.5 rounded-xl bg-emerald-400/5 border border-emerald-400/20 px-4 py-3">
                  <TrendingUp className="h-4 w-4 text-emerald-400 shrink-0" />
                  <p className="text-xs text-slate-300">
                    <span className="font-display text-base font-bold text-emerald-300 mr-1.5">{t.stat}</span>
                    {t.statLabel}
                  </p>
                </div>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
